import { PortableText, PortableTextComponents } from "@portabletext/react";

import { cn } from "@punchup/utils/cn";

interface LegalPortableTextProps {
  value: any;
  className?: string;
}

const components: PortableTextComponents = {
  block: {
    h1: ({ children }) => (
      <h1 className="text-4xl font-bold mb-4">{children}</h1>
    ),
    h2: ({ children }) => (
      <h2 className="text-2xl font-semibold mb-3">{children}</h2>
    ),
    h3: ({ children }) => (
      <h3 className="text-xl font-medium mb-2">{children}</h3>
    ),
    normal: ({ children }) => <p className="mb-4">{children}</p>,
  },
  list: {
    bullet: ({ children }) => (
      <ul className="list-disc ml-4 mb-4">{children}</ul>
    ),
    number: ({ children }) => (
      <ol className="list-decimal ml-4 mb-4">{children}</ol>
    ),
  },
  listItem: ({ children }) => <li className="mb-1">{children}</li>,
  marks: {
    link: ({ children, value }) => {
      const { href } = value;
      return (
        <a
          href={href}
          className="text-blue-600 hover:text-blue-800 underline underline-offset-2 transition-colors"
          target="_blank"
          rel="noopener noreferrer"
        >
          {children}
        </a>
      );
    },
  },
};

export default function LegalPortableText({
  value,
  className,
}: LegalPortableTextProps) {
  return (
    <div className={cn("", className)}>
      <PortableText value={value} components={components} />
    </div>
  );
}
